import { render, staticRenderFns } from "./vendor-register.vue?vue&type=template&id=4d66f4ec&scoped=true&"
import script from "./vendor-register.vue?vue&type=script&lang=js&"
export * from "./vendor-register.vue?vue&type=script&lang=js&"
import style0 from "./vendor-register.vue?vue&type=style&index=0&id=4d66f4ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d66f4ec",
  null
  
)

export default component.exports